<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2022-09-19 14:26:30
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2023-05-17 17:10:18
 * @FilePath: \exevnt\src\components\Legend.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div
    style="
      width: 70px;

      background-color: white;
      position: absolute;
      bottom: 10px;
      left: 10px;
      z-index: 999;
      box-shadow: 1px 1px 5px 1px #7f8c8d;
      border-radius: 5px;
      overflow: hidden;
      padding: 4px;
    "
  >
    <div v-for="item in list" class="legendItem">
      <div class="legendItemColor" :style="{ backgroundColor: item.color }"></div>
      <div class="legendItemText">{{ item.text }}</div>
    </div>
    <div style="text-align: center; width: 100%; height: 20px; font-size: 12px">图例(天)</div>
  </div>
</template>

<script>
import { legendColor } from "../map/mapImport";
export default {
  data() {
    return {
      list: []
    };
  },
  props: ["type"],
  created() {
    // console.log(legendColor[this.type]);
    JSON.parse(JSON.stringify(legendColor[this.type]))
      .reverse()
      .map(item => {
        this.list.push({
          color: `rgba(${item[1][0]},${item[1][1]},${item[1][2]})`,
          text: item[0]
        });
      });
    // console.log(this.list);
  }
};
</script>

<style>
.legendItem {
  display: flex;
  width: 80px;
  height: 30px;
}
.legendItemColor {
  width: 50%;
  height: 100%;
}
.legendItemText {
  width: 30%;
  height: 100%;
  font-size: 6px;
  text-align: center;
  line-height: 30px;
  font-weight: 500;
}
</style>